import React from 'react'
import DatasetDetailContent from '@/components/pages/DataInfoPage/dataset/DatasetDetailContent'
import DetailDialog from '@/components/pages/DataInfoPage/DetailDialog'
import { useQuery} from '@apollo/client'
import {useDispatch} from 'react-redux'
import {Box, CircularProgress} from '@mui/material'
import {DATASET_QUERY} from '@/graphql/query/queries'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import Typography from '@mui/material/Typography'
import {SET_DATASET_DETAIL} from '@/store/types'

type DatasetDetailDialogProps = {
    datasetId: string
}

/**
 * This dialog is always open. 
 * Control its visibility from an outside component due to proper data resetting.
 */
const DatasetDetailDialog = ({datasetId}: DatasetDetailDialogProps) => {

    const dispatch = useDispatch()

    const {
        data,
        loading,
        error
    } = useQuery(DATASET_QUERY, {variables: {datasetId}, notifyOnNetworkStatusChange: true, fetchPolicy: 'network-only'})

    return (
        <DetailDialog open onClose={() => dispatch(SET_DATASET_DETAIL(undefined))}
            header={'DATASET: ' + datasetId}>
            {loading && (<Box
                width="100%"
                alignItems="center"
                justifyContent="center"
                display="flex"
                flexDirection="column">
                <CircularProgress size="2em"/>
            </Box>)}
            {!!error && (<Box
                width="100%"
                alignItems="center"
                justifyContent="center"
                display="flex"
                flexDirection="column">
                <ErrorOutlineIcon color="error" fontSize="large"/>
                <Typography>Unable to get dataset with id: {datasetId}</Typography>
            </Box>)}
            {!!data && (<DatasetDetailContent dataset={data.dataset}/>)}
        </DetailDialog>
    )
}

export default DatasetDetailDialog